<template>
    <div>
        <template v-if="manage_super_admin === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Super Admin</h1>
                <router-link to="/addSuperAdmin" class="btn btn-primary float-right active"> Add SuperAdmin</router-link>
                <div class="searching float-right mr-2">
                    <input id="customSearch" type="text" class="form-control search" name="" />
                </div>
            </div>
            <table id="superAdminTable" class="table" width="100%">
                <thead>
                    <tr>
                        <th style="display: none;"></th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>City</th>
                        <th>Status</th>
                        <th class="text-center">Action</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-else-if="manage_super_admin === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="manage_super_admin === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    var superAdminTable = null;
    export default {
        data() {
            return {
                data : null,
                manage_super_admin: null
            };
        },
        mounted() {
            this.$Progress.start();
			this.can('manage_super_admin').then(result => {
                this.manage_super_admin = result.manage_super_admin;
            }).then(result => {
                if(this.manage_super_admin == true){
					this.callDataTable();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            callDataTable(){
                var that = this;
                superAdminTable = $('#superAdminTable').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: true,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/listSuperAdmin",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
						// "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'name'},
                        {data: 'email'},
                        {data: 'mobile_no'},
                        {render: function(data,type,full){
                            if(full.city != null){
                                return full.city.name;
                            }
                        }},
                        {data: 'status'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/editSuperAdmin/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit"><i class="fas fa-pencil-alt"></i></a>';
                        }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 5 ]
                    }],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
                $('#customSearch').on( 'keyup', function (e) {
                    if (e.keyCode === 13) {
                        superAdminTable.search(this.value).draw();
                    }
                });
                // $('#customSearch').on( 'keyup', function () {
                //     superAdminTable.search(this.value).draw();
                // });
            },
        },
    }
</script>
